import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { BrowserStorage } from 'utils/browserStorage';
import type { AnalyticsPersistedInput } from 'app/modules/analytics/utils/analyticsSelectionQuery';

const MAX_ITEMS = 6;

export interface LastUsedAnalyticsProfileEntry {
  id: number;
  name: string;
  type: number | null;
  logoSrc?: string;
}

interface LastUsedAnalyticsProfilesStore {
  profiles: LastUsedAnalyticsProfileEntry[];
  lastPageId: number | null;
  lastGroupId: number | null;
  addProfile: (profile: LastUsedAnalyticsProfileEntry) => void;
  setLastSelection: (selection: AnalyticsPersistedInput) => void;
}

export const useLastUsedAnalyticsProfilesStore =
  create<LastUsedAnalyticsProfilesStore>()(
    persist(
      (set) => ({
        profiles: [],
        lastPageId: null,
        lastGroupId: null,
        addProfile: (profile) => {
          set((state) => ({
            profiles: [
              profile,
              ...state.profiles.filter((p) => p.id !== profile.id),
            ].slice(0, MAX_ITEMS),
          }));
        },
        setLastSelection: ({ pageId, groupId }) => {
          set({ lastPageId: pageId, lastGroupId: groupId });
        },
      }),
      {
        name: BrowserStorage.keys.Analytics.LastUsedProfiles,
      },
    ),
  );
